import { createContext, useState, useEffect, useContext } from "react";
import CommonServices from "../services/commonServices";
import { useLoader } from "./loaderContext";

export const DocumentCategoryContext = createContext();

export const DocumentCategoryProvider = ({ children }) => {

    const { setLoading} = useLoader();
    const [documentCategories, setDocumentCategories] = useState(null);
    const [error, setError] = useState(null);


    useEffect(() => {
        retrieveDocumentCategoriesData();
    }, []);

    const retrieveDocumentCategoriesData = async () => {
        setLoading(true);
        try {
            const respData = await CommonServices.getDocumentCategories();
            if (respData.success) {
                const documentCategories = respData.responseObject.value.documentCategories;
                setDocumentCategories(documentCategories);
            }
            setLoading(false);
        } catch (error) {
            setError(error.message);
            setLoading(false);
            console.error('Failed to fetch:', error.message);
        }
    };

    return (
        <DocumentCategoryContext.Provider value={{ documentCategories, error }}>
            {children}
        </DocumentCategoryContext.Provider>
    )
}

export const useDocumentCategoryContext= () => useContext(DocumentCategoryContext);